const coreCoordinatorData = [
  {
    name: "Vardhan Bhardwaj",
    contact: "+91 9871844065",
    // course: "B.Tech CSE",
    image: "vardhan",
  },
  {
    name: "Ujjawal Chaudhary",
    contact: "+91 9990009342",
    // course: "B.Pharma",
    image: "Ujjawal",
  },
  {
    name: "Pranav vashistha",
    contact: "+91 9548577787",
    // course: "B.Tech IT",
    image: "Pranav",
  },

  {
    name: "Kanishak chaurasia",
    contact: "+91 9312442192",
    // course: "B.Tech CSE(AI)",
    image: "Kanishak",
  },
  {
    name: "Shivam Kumar",
    contact: "+91 6206349188",
    // course: "B.Tech CSE",
    image: "ShivamKumar",
  },
];
export default coreCoordinatorData;
